import { gsap } from "gsap";

import $ from "jquery";
window.jQuery = $;
window.$ = $;

function initCircleMovement() {
  const isPresent = document.querySelector(".yellow-circle-anim-wrapper");
  if (!isPresent) {
    return;
  }

  // const wrapper = document.querySelector(".yellow-circle-anim-wrapper");
  const wrapper = document.body;

  const element = document.querySelector(".yellow-anim-circle");

  wrapper.addEventListener("mousemove", (e) => {
    var objLeft = $(element).offset().left;
    var objTop = $(element).offset().top;

    // console.log(objLeft, objTop);

    var objCenterX = objLeft + $(element).width() / 2;
    var objCenterY = objTop + $(element).height() / 2;

    const x = (e.pageX - objCenterX) / 20;
    const y = (e.pageY - objCenterY) / 20;

    let moveX = x ? -x : x;
    let moveY = y ? -y : y;

    gsap.to(element, { x: moveX, y: moveY, duration: 1 });
  });

  wrapper.addEventListener("mouseleave", (e) => {
    gsap.to(element, { x: 0, y: 0, duration: 1 });
  });
}

export { initCircleMovement };

function initRedCircleMovement() {
  const isPresent = document.querySelector(".red-circle-anim-wrapper");
  if (!isPresent) {
    return;
  }

  // const wrapper = document.querySelector(".red-circle-anim-wrapper");
  const wrapper = document.body;

  const element = document.querySelector(".red-anim-circle");

  wrapper.addEventListener("mousemove", (e) => {
    var objLeft = $(element).offset().left;
    var objTop = $(element).offset().top;

    // console.log(objLeft, objTop);

    var objCenterX = objLeft + $(element).width() / 1.9;
    var objCenterY = objTop + $(element).height() / 2.1;

    const x = (e.pageX - objCenterX) / 22;
    const y = (e.pageY - objCenterY) / 18;

    let moveX = x ? -x : x;
    let moveY = y ? -y : y;

    gsap.to(element, { x: moveX, y: moveY, duration: 1, delay: 0.05 });
  });

  wrapper.addEventListener("mouseleave", (e) => {
    gsap.to(element, { x: 0, y: 0, duration: 1, delay: 0.05 });
  });
}

export { initRedCircleMovement };
